<mat-form-field appearance="legacy" fxFlex *ngIf="!selectedAddress">
  <mat-label>
    {{ 'ADDRESS_INPUT.LABEL' | translate }}
  </mat-label>
  <input
    [readonly]="!editableValue"
    type="text"
    matInput
    fxFlex="100"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    required
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedAddress()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let address of addresses" [value]="address">
      {{ address.formattedAddress }}
    </mat-option>
    <mat-option *ngIf="!addresses.length">
      {{ 'ADDRESS_INPUT.ERRORS.NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>

  <mat-error>
    {{ 'ADDRESS_INPUT.ERRORS.REQUIRED' | translate }}
  </mat-error>
</mat-form-field>

<div fxFlex *ngIf="selectedAddress">
  <mat-form-field
    class="selected-address"
    appearance="legacy"
    [matTooltip]="selectedAddress"
    [matTooltipDisabled]="!isViewMode"
  >
    <mat-label>
      {{ 'ADDRESS_INPUT.ADDRESS' | translate }}
    </mat-label>
    <div class="flex">
      <input type="text" required matInput disabled [value]="selectedAddress" data-cy="formatted-address-input" />
      <button
        *ngIf="!isViewMode && selectedAddress && editableValue"
        mat-icon-button
        class="input-address-cancel-button accent-700-fg"
        (click)="deselectAddress()"
      >
        <mat-icon class="font-size-20">cancel</mat-icon>
      </button>
    </div>
  </mat-form-field>
</div>

<div class="address-message" [style.margin]="'-1.25em 0 0'">
  <div *ngFor="let error of validation?.errors" class="address-message__error">
    <mat-icon>error</mat-icon>
    <span>
      {{ error }}
    </span>
  </div>
  <div *ngFor="let warning of validation?.warnings" class="address-message__warning">
    <mat-icon>warning</mat-icon>
    <span>
      {{ warning }}
    </span>
  </div>
</div>
